import { Container } from "../../../common/components/container/Container";
import { CustomTabs } from "../../../common/components/Tabs/CustomTabs";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { FaRegCalendarTimes } from "react-icons/fa";
import { MdOutlineAccessTime } from "react-icons/md";
import { PublicHoliday } from "./components/publicHoliday/PublicHoliday";
import { WorkShedule } from "./components/workShedule/WorkShedule";
import { Suspense } from "react";
import { Loader } from "../../../common/components/Loader/Loader";

export const WorkCalendar = () => {
  const ITEMS = [
    {
      key: "public-holiday",
      label: "Jour férié",
      icon: <FaRegCalendarTimes size={20} />,
      children: (
        <Suspense fallback={<Loader isLoading />}>
          <PublicHoliday />
        </Suspense>
      ),
    },
    {
      key: "work-shedule",
      label: "Horaire de travail",
      icon: <MdOutlineAccessTime size={20} />,

      children: (
        <Suspense fallback={<Loader isLoading />}>
          <WorkShedule />
        </Suspense>
      ),
    },
  ];

  return (
    <div>
      <TitleHeader title="Calendrier de travail" />

      <Container>
        <CustomTabs
          isSetDefaultActive={true}
          isUppercase={false}
          items={ITEMS}
          tabName="type"
        />
      </Container>
    </div>
  );
};
